import React from "react";
import Typography from "../../../Components/Typography/Typography";
import { Col, Container, Row } from "react-bootstrap";
import Img from "../../../assets/images/image";
import Animation from "../../../animations/Animation";

export default function RewardsAndRecognition() {
   return (
      <Container>
         <Row>
            <Col xs={12} sm={12} md={6} className="my-3">
               <Animation fade bottom>
                  <Typography element="span" className="font-26" fontWeight={600} syne>
                     Rewards and <br /> Recognition
                  </Typography>
               </Animation>
            </Col>
            <Col xs={12} sm={12} md={6} className="my-3">
               <Animation fade bottom>
                  <Row>
                     <Col xs={6} sm={6} md={3}>
                        <img src={Img.rewardsColor1} alt="no img" className="img-fluid" />
                     </Col>
                     <Col xs={6} sm={6} md={3}>
                        <img src={Img.rewardsColor2} alt="no img" className="img-fluid" />
                     </Col>
                     <Col xs={6} sm={6} md={3} className="px-3">
                        <img src={Img.rewardsColor3} alt="no img" className="img-fluid" />
                     </Col>
                     <Col xs={6} sm={6} md={3} className="px-3">
                        <img src={Img.rewardsColor4} alt="no img" className="img-fluid" />
                     </Col>
                  </Row>
               </Animation>
            </Col>
         </Row>
      </Container>
   );
}
